export const networkType = [
  { name: "4G", value: "4G" },
  { name: "5G", value: "5G" },
];
